import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class ExpenseService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    try{
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    }catch(e){}
  }

  ESS_ExpenseCategoryMaster_InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ExpenseCategoryMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ExpenseCategoryMasterSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ExpenseCategoryMaster/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_VehicleMasterSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_VehicleMaster/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_VehicleMaster_InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_VehicleMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ExpenseRule_InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ExpenseRule_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ExpenseRule_LoadUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ExpenseRule_Load/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ExpenseRequest_ComboLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ExpenseRequest_Combo/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ExpenseRequestInsert(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ExpenseRequest/Insert`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ExpenseRequest_SelectGet(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ExpenseRequest_Select/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TripMaster_InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_TripMaster_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_TripMaster_SelectUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_TripMaster_Select/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ExpenseAdvanceRequest_InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ExpenseAdvanceRequest_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ExpenseAdvanceRequest_SelectUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ExpenseAdvanceRequest_Select/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ExpenseRequestUpdateAtApproval(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ExpenseRequestUpdate/AtApproval`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  Proc_ESS_ExpenseAdvanceUpdateAtApproval(Detail: any) {
    return this.http.post<any>(environment.API_URL + `Proc_ESS_ExpenseAdvanceUpdate/AtApproval`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ExpenseReport(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ExpenseReport/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
